import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const schema = yup
  .object({
    type: yup.object().nullable().label('Type'),
    label: yup.string().max(80).required().trim().label('Label'),
    value: yup.string().max(80).trim().label('Value'),
    parent_value: yup.string().max(80).trim().label('Parent Value'),
  })
  .required()

const resAddFilterValue = yupResolver(schema)

export default resAddFilterValue
